const menuList = [
  /* { title: 'message.layout.project', icon: 'mdi-developer-board', to: '/projectsharepoint/123?name=testProject' },
  { title: 'message.layout.company', icon: 'mdi-developer-board', to: '/companysharepoint/100?name=testCompany' }, */
  { title: 'message.layout.dashboard', icon: 'mdi-view-dashboard', to: '/dashboard' },
  { title: 'message.layout.hourlogging', icon: 'mdi-timetable', to: '/hourlogging' },
  /* { title: 'message.layout.stampTime', icon: 'mdi-av-timer', to: '/stamptime' }, */
  { title: 'message.layout.projects', icon: 'mdi-developer-board', to: '/projects' },
  { title: 'message.layout.approval', icon: 'mdi-fingerprint', to: '/approval' },
  { title: 'message.layout.reports', icon: 'mdi-file-document', to: '/reports' },
  // { title: 'message.layout.worktypes', isSettings: true, isSettingItem: true, icon: 'mdi-file-tree', to: '/worktypes' },
  { title: 'message.layout.activities', isSettings: true, isSettingItem: true, icon: 'mdi-image-filter-tilt-shift', to: '/activities' },
  { title: 'message.layout.holidays', isSettingItem: true, icon: 'mdi-calendar-multiple', to: '/holidays' },
  { title: 'message.layout.user', isSettingItem: true, icon: 'mdi-account', to: '/user' },
  { title: 'message.layout.companySettings', isSettingItem: true, icon: 'mdi-account-settings', to: '/company_settings' },
  { title: 'message.layout.sharepointSettings', isSettingItem: true, icon: 'mdi-cloud-sync', to: '/sharepoint_settings' }
]
export default menuList
